export default __webpack_public_path__ + "static/media/Inactive-hcp-icon-new.ffe540f7.svg";